import { useEffect, useState } from "react";
import { AdminApi, type OrganizerVerificationRequest } from "../api/admin";
import { RejectReasonModal } from "../components/RejectReasonModal";

export const VerificationOrganizersPage = () => {
  const [items, setItems] = useState<OrganizerVerificationRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [statusFilter, setStatusFilter] = useState<string>("PENDING");
  const [rejectTarget, setRejectTarget] = useState<OrganizerVerificationRequest | null>(null);

  const load = () => {
    setLoading(true);
    setError(null);
    AdminApi.listOrganizerVerificationRequests({ status_filter: statusFilter || undefined })
      .then((res) => setItems(res.data))
      .catch((e) => setError(e?.response?.data?.detail || "Ошибка загрузки"))
      .finally(() => setLoading(false));
  };

  useEffect(load, [statusFilter]);

  const approve = async (id: number) => {
    if (!confirm("Одобрить заявку?")) return;
    await AdminApi.approveOrganizerVerification(id);
    load();
  };
  const submitReject = async (reason: string) => {
    if (!rejectTarget) return;
    await AdminApi.rejectOrganizerVerification(rejectTarget.id, reason);
    setRejectTarget(null);
    load();
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold text-slate-900 mb-1">Верификация организаторов</h1>
      <p className="text-sm text-slate-500 mb-6">Заявки на верификацию деятельности от организаторов</p>

      <div className="mb-4">
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className="border border-slate-300 rounded-md px-3 py-2 text-sm bg-white"
        >
          <option value="PENDING">На рассмотрении</option>
          <option value="APPROVED">Одобренные</option>
          <option value="REJECTED">Отклонённые</option>
          <option value="">Все</option>
        </select>
      </div>

      {loading && <div className="py-10 text-center text-slate-500">Загрузка...</div>}
      {error && <div className="py-10 text-center text-red-600">{error}</div>}

      {!loading && !error && (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-slate-50 text-slate-600">
              <tr>
                <th className="text-left px-4 py-3 font-medium">ID</th>
                <th className="text-left px-4 py-3 font-medium">Email</th>
                <th className="text-left px-4 py-3 font-medium">Компания</th>
                <th className="text-left px-4 py-3 font-medium">Документ</th>
                <th className="text-left px-4 py-3 font-medium">Статус</th>
                <th className="text-left px-4 py-3 font-medium">Создано</th>
                <th className="text-left px-4 py-3 font-medium">Действия</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (
                <tr><td colSpan={7} className="px-4 py-10 text-center text-slate-500">Нет заявок</td></tr>
              )}
              {items.map((r) => (
                <tr key={r.id} className="border-t border-slate-100 hover:bg-slate-50">
                  <td className="px-4 py-2.5 text-slate-500">{r.id}</td>
                  <td className="px-4 py-2.5 font-medium">{r.organizer_email}</td>
                  <td className="px-4 py-2.5">{r.organizer_company || "—"}</td>
                  <td className="px-4 py-2.5">
                    {r.document_path ? (
                      <a href={r.document_path} target="_blank" rel="noreferrer" className="text-brand underline">
                        Открыть
                      </a>
                    ) : "—"}
                  </td>
                  <td className="px-4 py-2.5">
                    <span className="inline-block px-2 py-0.5 rounded text-xs font-mono bg-slate-100">{r.status}</span>
                  </td>
                  <td className="px-4 py-2.5 text-slate-500">{r.created_at ? new Date(r.created_at).toLocaleDateString() : "—"}</td>
                  <td className="px-4 py-2.5">
                    {r.status === "PENDING" && (
                      <div className="flex gap-2">
                        <button onClick={() => approve(r.id)} className="px-2.5 py-1 bg-emerald-600 text-white rounded text-xs hover:opacity-90">
                          Одобрить
                        </button>
                        <button onClick={() => setRejectTarget(r)} className="px-2.5 py-1 bg-red-600 text-white rounded text-xs hover:opacity-90">
                          Отклонить
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <RejectReasonModal
        isOpen={!!rejectTarget}
        title="Отклонить заявку на верификацию организатора"
        subjectEmail={rejectTarget?.organizer_email}
        onClose={() => setRejectTarget(null)}
        onSubmit={submitReject}
      />
    </div>
  );
};
